export const BOGO = 'bogo';
export const MSB = 'msb';
export const BMSM = 'bmsm';

export const PROMOTION_TYPES = [
  BOGO, MSB, BMSM,
];

export const MAX_NUM_TIERS_IN_PROMOTION = 5;
export const NUM_NON_GROUPED_TIERS = 3;
export const MULTI_SELECT_QUANTITY = 1;

export const BANNED_BRAND_NAMES = ['LG Electronics', 'LG SIGNATURE', 'LG STUDIO'];
export const MA = 'MAJOR_APPLIANCE';
export const GM = 'MERCHANDISE';
export const NVALUE_REFINEMENT_SEPARATOR = 'Z';
